import styled, {keyframes} from 'styled-components';

import {Hint} from 'components/ui-kit/Hint';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {colors, font} from 'theme';

export const ButtonsContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: sticky;
    bottom: 0;
    padding: 10px 0;
    background: ${colors.white};
`;

export const ButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    justify-content: stretch;
    align-items: center;
`;

export const ReportBugContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100%;
`;

export const ReportBugHeadline = styled.h4`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${colors.darkGrey};
    margin: 6px 0;
    padding: 0;
`;

export const ReportBugDescription = styled.p`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textSecondary};
    margin: 0 0 6px 0;
    padding: 0;

    > a {
        font-family: ${font.family.primary};
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: ${colors.brandPrimary};
        text-decoration: underline;
    }
`;

export const CustomContentContainer = styled(ContentContainer)`
    padding: 0;
    max-height: 63vh;
    overflow: auto;
`;

export const FormFields = styled.div`
    display: grid;
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;
`;

export const Field = styled(Hint)<{font?: {size: string; color: string}}>`
    display: flex;
    flex-flow: column wrap;

    > span {
        font-size: ${({font}) => font?.size || '12px'};
        color: ${({font}) => colors[font?.color as keyof typeof colors] || colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 80px;

    animation: ${opacity} 2s ease;
`;
